import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import HamburgerMenu from './HamburgerMenu';
import SchoolLogo from './SchoolLogo';

function HeaderWithHamburger({ tenant, linkToDashboard, listItems }) {
  const { t } = useTranslation();
  const colorPrimary = {
    color: `${tenant.primary}`,
  };

  const borderTopSecondary = {
    borderTop: `9px solid ${tenant.secondary}`,
  };

  return (
    <div className="header" style={borderTopSecondary}>
      <div className="left-side-header">
        <div className="header-logo-container">
          <SchoolLogo
            schoolLogoWidth="75%"
            horizontalAlign="flex-start"
            schoolLogoContainerWidth="100%"
          />
        </div>
        {linkToDashboard && (
          <Link to="dashboard">
            <p className="primary-link" style={colorPrimary}>
              {t('Back to Dashboard')}
            </p>
          </Link>
        )}
      </div>
      <HamburgerMenu
        tenant={tenant}
        gtmLocation="dashboard hamburger menu"
        listItems={listItems}
      />
    </div>
  );
}

HeaderWithHamburger.propTypes = {
  tenant: PropTypes.object.isRequired,
};

export default connect(null, {})(HeaderWithHamburger);
